/**
 * CancelAlternativesScreen — adaptateur primaire de la route `cancel-alternatives` (étape 2/5).
 *
 * Fil : le view-model choisit l'alternative sur le motif, l'état route ses gestes.
 */
import React from "react"
import { useSelector } from "react-redux"

import { CancelAlternativesPage } from "../../../../../../design-system"
import { cancelAlternativesViewModel } from "../../../../view-models/parent/SubscriptionCancel/cancelAlternativesViewModel"
import { type CancelFlowScreenProps } from "./cancelFlowNavigation"
import { useCancelAlternativesState } from "./useCancelAlternativesState"

export function CancelAlternativesScreen(props: CancelFlowScreenProps) {
    const routeParams = props.route?.params ?? {}
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const vm = useSelector((state: any) => cancelAlternativesViewModel(state, routeParams.motif))
    const actions = useCancelAlternativesState({
        routeParams,
        calendlySubject: vm.calendlySubject,
    })

    return (
        <CancelAlternativesPage
            alternative={vm.alternative}
            onAction={actions.onAction}
            onContinue={actions.onContinue}
            onBack={actions.onBack}
            onClose={actions.onClose}
        />
    )
}

export default CancelAlternativesScreen
